let Socket = ''
let setIntervalWesocketPush = null;
import Cookies from "js-cookie";
// const socketUrl = 'ws://58.58.90.178:7001/wsapi?token=59cf8cd60f15aeedc5ebb59f248529ee'  // socket连接地址
// const socketUrl = Cookies.get('socketUrl')
/**
 * 建立websocket连接
 * @param {string} url ws地址
 */
export const createSocket = (url) => {
  Socket && Socket.close()
  if (!Socket) {
    // console.log('建立websocket连接')
    Socket = new WebSocket(url)
    Socket.onopen = onopenWS
    Socket.onmessage = onmessageWS
    Socket.onerror = onerrorWS
    Socket.onclose = oncloseWS
  } else {
    // console.log('websocket已连接')
  }
}

/**打开WS之后发送心跳 */
const onopenWS = () => {
  sendPing()
}

/**连接失败重连 */
const onerrorWS = () => {
  Socket.close()
  clearInterval(setIntervalWesocketPush)
  console.log('连接失败重连中')
  if (Socket.readyState !== 3) {
    Socket = null
    let token = Cookies.get('socketUrl').split("/ws/")[1];
    if (token && token.length > 10) {
      setTimeout(function(){
        createSocket(Cookies.get('socketUrl'))
      }, 10000);
    }
  }
}

/**WS数据接收统一处理 */
const onmessageWS = e => {
  // 修改结构当不是ping再添加到监听事件中
  // console.log(e.data)
  if (e.data && e.data !== 'ping') {
    window.dispatchEvent(new CustomEvent('onmessageWS', {
      detail: {
        data: e.data
      }
    }))
  }
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
  setTimeout(() => {
    if (Socket.readyState === 0) {
      connecting(message)
    } else {
      Socket.send(JSON.stringify(message))
    }
  }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = message => {
  if (Socket !== null && Socket.readyState === 3) {
    Socket.close()
    createSocket(Cookies.get('socketUrl'))
  } else if (Socket.readyState === 1) {
    Socket.send(JSON.stringify(message))
  } else if (Socket.readyState === 0) {
    connecting(message)
  }
}

/**断开重连 */
const oncloseWS = () => {
  clearInterval(setIntervalWesocketPush)
  // console.log('websocket已断开....正在尝试重连')
  if (Socket.readyState !== 2) {
    Socket = null
    let token = Cookies.get('socketUrl').split("/ws/")[1];
    if (token && token.length > 10) {
      setTimeout(function(){
        createSocket(Cookies.get('socketUrl'))
      }, 10000);
    }
  }
}
/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const sendPing = (time = 5000, ping = 'ping') => {
  clearInterval(setIntervalWesocketPush)
  Socket.send(ping)
  setIntervalWesocketPush = setInterval(() => {
    Socket.send(ping)
  }, time)
}
